import { render } from "./ProgrammiUserCheckFinale.vue?vue&type=template&id=327a9eaf&scoped=true"
import script from "./ProgrammiUserCheckFinale.vue?vue&type=script&lang=js"
export * from "./ProgrammiUserCheckFinale.vue?vue&type=script&lang=js"

import "./styles/ProgrammiUserForm.css?vue&type=style&index=0&id=327a9eaf&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327a9eaf"]])

export default __exports__